// extracted by mini-css-extract-plugin
export default {"loader":"LoaderWithOverlay_loader__2v0C3","loaderOverlay":"LoaderWithOverlay_loaderOverlay__2901g"};